import { IAPM } from './apm.types';
import { createCoralogixAPM } from './apm-wrapper';
import { createNoopAPM } from './noop-apm';

/**
 * APM factory.
 *
 * The Coralogix RUM SDK itself is loaded externally by the script tag in
 * public/index.html and initialized there using REACT_APP_APM_* env vars.
 * This factory only decides whether the in-app wrapper talks to that SDK or
 * falls back to a no-op.
 */
function initAPM(): IAPM {
    const enabled = process.env.REACT_APP_APM_ENABLED === 'true';

    if (!enabled) {
        console.warn(
            '[APM] APM is disabled (REACT_APP_APM_ENABLED is not "true")'
        );
        return createNoopAPM();
    }

    try {
        return createCoralogixAPM();
    } catch (e) {
        console.error(
            '[APM] Failed to initialize Coralogix RUM wrapper, falling back to no-op:',
            e
        );
        return createNoopAPM();
    }
}

const APM: IAPM = initAPM();

export default APM;
export { LogActionType, SubModule } from './apm.enum';
export type { IAPM, APMConfig } from './apm.types';
